import styled from "styled-components";

export const UsdtContent = styled.div`
  width: 100%;
  height: 100%;
`;
